// Official brand assets — The Royal Mahaveer Roadlines Pvt Ltd
// /logo.png = full lockup (mark + wordmark + tagline), /logo-mark.png = road & diamond mark only.

export function BrandMark({ className = "h-10 w-10" }) {
  return (
    <img
      src="/logo-mark.png"
      alt="The Royal Mahaveer Roadlines emblem — golden road rising to a diamond"
      className={`object-contain ${className}`}
    />
  );
}

export function FullLogo({ className = "" }) {
  return (
    <img
      src="/logo.png"
      alt="The Royal Mahaveer Roadlines Pvt Ltd — official logo"
      className={`object-contain ${className}`}
    />
  );
}

export function Emblem({ compact = false }) {
  return (
    <span className="flex items-center gap-3" data-testid="brand-emblem">
      <BrandMark className={compact ? "h-10 w-10" : "h-12 w-12"} />
      <span className="leading-none">
        <span className="block font-heading text-[15px] font-semibold tracking-[0.12em] text-foreground">
          THE ROYAL MAHAVEER
        </span>
        <span className="mt-1 block text-[9px] font-semibold uppercase tracking-[0.34em] text-gold">
          Roadlines Pvt Ltd
        </span>
      </span>
    </span>
  );
}
